import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'
import { FunctionComponent } from 'react'

/**
 * A collapsible section header that lives inside the bordered form-row list (same border
 * geometry as FormTextInputDisplay), so optional groups of rows fold away without breaking
 * the list's visual rhythm. Title sits where row titles sit; the chevron sits at the far right.
 */
export const FormSectionToggleRow: FunctionComponent<{
  title: string,
  caption?: string,
  open: boolean,
  onToggle: () => void,
  isBottomRow?: boolean,
}> = ({ title, caption, open, onToggle, isBottomRow = false }) => {
  return (
    <Stack
      onClick={onToggle}
      direction='row'
      alignItems='center'
      justifyContent='space-between'
      sx={{
        borderWidth: '1px',
        borderColor: 'lightGrey.main',
        borderTopStyle: 'solid',
        borderLeftStyle: 'solid',
        borderRightStyle: 'solid',
        borderBottomStyle: isBottomRow ? 'solid' : 'none',
        borderBottomLeftRadius: isBottomRow ? '10px' : 0,
        borderBottomRightRadius: isBottomRow ? '10px' : 0,
        pl: 3, pr: 2, pt: 1.5, pb: 1.5,
        cursor: 'pointer',
        userSelect: 'none',
        '&:hover': { backgroundColor: 'action.hover' },
      }}
    >
      <Stack direction='row' alignItems='center'>
        <Typography variant='subtitle1'>{title}</Typography>
        {caption &&
          <Typography variant='body2' sx={{ color: 'text.secondary', pl: 1.5 }}>{caption}</Typography>}
      </Stack>
      {open ? <KeyboardArrowUp sx={{ color: 'text.secondary' }} /> : <KeyboardArrowDown sx={{ color: 'text.secondary' }} />}
    </Stack>
  )
}
